import { gql, QueryHookOptions, useLazyQuery } from '@apollo/client';

type TData = { videos: Video[] };
type TVariables = { isShow: boolean; competitionId: string; isLimit: boolean };

export const useVideos = (options?: QueryHookOptions<TData, TVariables>) => {
    return useLazyQuery<TData, TVariables>(VIDEOS, options);
};

export const VIDEOS = gql`
    query Videos($isShow: Boolean!, $competitionId: String!, $isLimit: Boolean!) {
        videos(isShow: $isShow, competitionId: $competitionId, isLimit: $isLimit) {
            _id
            userId {
                _id
                name
            }
            videoUrl
            liked
            competitionId
        }
    }
`;
